var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "filter__filters d-flex flex-column flex-md-row justify-content-between align-items-center",
    },
    [
      _c("p", { staticClass: "filter__filters-label" }, [
        _vm._v(_vm._s(_vm.GuidesLandingPageFilterLabel)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "filter__filters-controls flex-column flex-sm-row d-flex align-items-center flex-wrap",
        },
        [
          _vm._l(_vm.filters, function (filter, index) {
            return _c("fragment", { key: index }, [
              _c("div", { staticClass: "form-group" }, [
                filter.type == "select"
                  ? _c(
                      "select",
                      {
                        directives: [{ name: "select2", rawName: "v-select2" }],
                        ref: "select2Elem",
                        refInFor: true,
                        staticClass: "form-control",
                        attrs: { id: `filter-${index}` },
                        domProps: { value: filter.selected },
                        on: {
                          change: function ($event) {
                            return _vm.handleFilterChange($event, filter.key)
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            staticClass: "option-label",
                            attrs: { hidden: "", disabled: "disabled" },
                            domProps: { value: null },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(filter.label) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(filter.options, function (filterOption) {
                          return _c(
                            "option",
                            { domProps: { value: filterOption.value } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(filterOption.text) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                filter.type == "checkbox"
                  ? _c("div", { staticClass: "filter__filters-checkbox" }, [
                      _c("label", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(filter.label) +
                            "\n                        "
                        ),
                        _c("input", {
                          staticClass: "form-control",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: filter.selected,
                            value: filter.value,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleCheckFilterChange(
                                $event,
                                filter.key
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span"),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ])
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.clearButtonVisible
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary btn-clear",
                      attrs: { type: "submit" },
                      on: { click: _vm.handleClearFilter },
                    },
                    [_vm._v(_vm._s(_vm.FiltersClearText))]
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }